import { render, staticRenderFns } from "./WithholdingView.vue?vue&type=template&id=05a6ff47&scoped=true"
import script from "./WithholdingView.vue?vue&type=script&lang=js"
export * from "./WithholdingView.vue?vue&type=script&lang=js"
import style0 from "./WithholdingView.vue?vue&type=style&index=0&id=05a6ff47&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05a6ff47",
  null
  
)

export default component.exports